import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/service/login.service';
import { LoadingState } from '../loading/loading-state';
import { CommonService } from '../../service/common.service';
import { SESSION_KEY } from '../../constant/session-constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

/**
 * ヘッダー
 */
export class HeaderComponent implements OnInit {
  // ヘッダー判定フラグ(true:通常モード、false:メッセージモード)
  @Input() headerFlag: boolean;

  // 文字サイズ選択項目
  textSizeList: Object[] = [
    {
      name: '標準',
      code: 'false',
    },
    {
      name: '拡大',
      code: 'true',
    },
  ];

  // 文字サイズ
  textSize: string;

  loginStatus: boolean = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private loginService: LoginService,
    private loadingState: LoadingState
  ) {}

  ngOnInit() {

    // Auth0ログイン状態取得
    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット
      this.loginStatus = response;
    });
    // セッションから文字サイズを取得
    let textSize: string = window.sessionStorage.getItem(SESSION_KEY.textSize);

    // 文字サイズが存在するか否か
    if (textSize) {
      // セッション.文字サイズを格納する
      this.textSize = textSize;
      // 文字サイズが存在する場合
    } else {
      this.textSize = 'false';

      // セッションに文字サイズの初期値を設定
      window.sessionStorage.setItem(SESSION_KEY.textSize, 'false');
    }
  }

  /**
   * 文字サイズ変更
   */
  public textChange() {
    // セッションに文字サイズを格納
    window.sessionStorage.setItem(SESSION_KEY.textSize, this.textSize);
  }

  /**
   * ホームページへ遷移する
   */
  public moveHome(): void {
    // ホームページへ遷移
    window.location.href = 'https://future-city.go.jp/platform/';
  }

  /**
   * 入会申請(A201)へ遷移する
   */
  public moveA201(): void {
    // 入会申請(A201)へ遷移
    this.router.navigate(['pages/platform/a201/a201']);
  }

  /**
   * マイページ(B301)へ遷移する
   */
  public moveB301(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/b301']);
  }

  /**
   * ID・パスワード登録(A210)へ遷移する
   */
  public moveA210(): void {
    //ID・パスワード登録(A210)へ遷移
    this.router.navigate(['pages/platform/a210']);
  }
}
